import {observer} from "mobx-react";
import dayjs from "dayjs";
import EventIcon from "@mui/icons-material/Event";
import SyncProblemIcon from "@mui/icons-material/SyncProblem";
import LayoutContentWrapper from "../../../components/layout/LayoutContentWrapper";
import * as React from "react";
import {useNavigatorFeature} from "../../../useFeature";
import ListOrdersFeature from "./ListOrdersFeature";
import {useApplication} from "../../../ApplicationProvider";
import {useNavigate} from "react-router-dom";
import FilledButton from "../../../components/buttons/FilledButton";
import LayoutContentToolbar from "../../../components/layout/LayoutContentToolbar";
import RefreshIcon from '@mui/icons-material/Refresh';
import Table from "../../../components/table/Table";
import FormDateField from "../../../components/fields/FormDateField";
import FormSection from "../../../forms/FormSection";
import FormRow from "../../../forms/FormRow";
import {renderAuthorizationStateIcon} from "../../../components/state/AuthorizationStateRenderer";

function ListOrdersScreen() {
    const application = useApplication();
    const navigator = useNavigate();
    const feature = useNavigatorFeature(() => new ListOrdersFeature(application, navigator), navigator);

    const isFeatureReady = (feature) => {
        return feature && feature.loaded
    }

    const listOrdersContent = () => {
        return (
            <div>
                <LayoutContentToolbar title="Pedidos">
                    <FilledButton onClick={() => feature.reload()}>
                        <RefreshIcon fontSize="small"/>
                        Actualizar
                    </FilledButton>
                </LayoutContentToolbar>

                <FormSection title="Fecha de entrega">
                    <FormRow>
                        <FormDateField
                            label="Desde"
                            field={feature.fromDateField()}
                        />
                        <FormDateField
                            label="Hasta"
                            field={feature.toDateField()}
                        />
                    </FormRow>
                </FormSection>

                <Table columns={feature.columns()} rows={feature.presentedOrders()}
                       navigateToRowObjectScreen={(params) => {
                           const url = feature.orderScreenUrl(params.row);
                           window.open(url, '_blank')}}
                       columnsRenderer={{
                            authorizationState: renderAuthorizationStateIcon
                        }}
                       quickFilters={[
                           {
                               label: 'Entrega mañana',
                               icon: <EventIcon/>,
                               predicate: (row) => row.deliveryDate === dayjs().add(1, 'day').format('DD-MM-YYYY'),
                           },
                           {
                               label: 'Fallo en transmisión',
                               icon: <SyncProblemIcon/>,
                               predicate: (row) => row.state === 'FALLO EN TRANSMISIÓN',
                           },
                       ]}
                />

            </div>
        )
    }

    return (
        <LayoutContentWrapper isLoading={!isFeatureReady(feature)} renderContent={() => listOrdersContent()}/>
    )
}

export default observer(ListOrdersScreen)
